/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchingCriteria } from './MatchingCriteria';
import {
    MatchingCriteriaFromJSON,
    MatchingCriteriaFromJSONTyped,
    MatchingCriteriaToJSON,
    MatchingCriteriaToJSONTyped,
} from './MatchingCriteria';

/**
 * 
 * @export
 * @interface Match
 */
export interface Match {
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    description?: string;
    /**
     * 
     * @type {MatchingCriteria}
     * @memberof Match
     */
    matchingCriteria?: MatchingCriteria;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    pattern?: string;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    expression?: string;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    matchType?: string;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    propertyName?: string;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    matchValue?: string;
}

/**
 * Check if a given object implements the Match interface.
 */
export function instanceOfMatch(value: object): value is Match {
    return true;
}

export function MatchFromJSON(json: any): Match {
    return MatchFromJSONTyped(json, false);
}

export function MatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): Match {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'matchingCriteria': json['matchingCriteria'] == null ? undefined : MatchingCriteriaFromJSON(json['matchingCriteria']),
        'pattern': json['pattern'] == null ? undefined : json['pattern'],
        'expression': json['expression'] == null ? undefined : json['expression'],
        'matchType': json['matchType'] == null ? undefined : json['matchType'],
        'propertyName': json['propertyName'] == null ? undefined : json['propertyName'],
        'matchValue': json['matchValue'] == null ? undefined : json['matchValue'],
    };
}

export function MatchToJSON(json: any): Match {
    return MatchToJSONTyped(json, false);
}

export function MatchToJSONTyped(value?: Match | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'description': value['description'],
        'matchingCriteria': MatchingCriteriaToJSON(value['matchingCriteria']),
        'pattern': value['pattern'],
        'expression': value['expression'],
        'matchType': value['matchType'],
        'propertyName': value['propertyName'],
        'matchValue': value['matchValue'],
    };
}

